import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { TSuperExerciseComponent } from '../t-super-exercise/t-super-exercise.component';
import { NumberCardsService } from '../number-cards.service';

@Component({
  selector: 'app-t-discover',
  templateUrl: './t-discover.component.html',
  styleUrls: ['./t-discover.component.css']
})
export class TDiscoverComponent extends TSuperExerciseComponent {

  hints: any[][] =[[{value:undefined, representation:""}]];
  hintsLength: number = 1;
  hintSetsLength: number[] = [1];
  requested: number[] = [undefined,undefined];
  given: string[] = [undefined,undefined];
  requestedLength = 2;
  helptext;
  notesStart: number = 1;
  notesEnd: number = 20;

  constructor(protected topicService: TopicService,  protected activatedRoute: ActivatedRoute, protected numberCardsService: NumberCardsService) {
    super(activatedRoute, numberCardsService, topicService);
   }

   ngOnInit() {
    super.ngOnInit();
    this.type = "discover";
    this.title = this.get("discoveryExercise");
  }

   generate(){
     super.generate();
     this.hints = [];
     this.hintsLength = 0;
     this.hintSetsLength = [];
     for(let i of this.createArray(3)){
       this.addHint();
       this.hints[i][0].value = Math.floor(Math.random() * 100 + 1);
       for(let j of this.createArray(2)){
        this.addRow(i);
        this.hints[i][j+1].value = Math.floor(Math.random() * 100 + 1);
       }
     }
     for(let i of this.createArray(2)){
      this.requested[i] = Math.floor(Math.random() * 100);
    }
    this.notesStart = 1;
    this.notesEnd = 100;
     this.onChangeRepr();
   }

    /** sets information based on configuration */
  setInformationWithConfiguration(){
    super.setInformationWithConfiguration();
   this.hints = [];
   this.hintSetsLength = [];
   for(let set of this.configuration.typespecifics.hints){
     let hintset = [];
     this.hintSetsLength.push(set.length);
     for(let hint of set){
       hintset.push({value: hint, representation: ""});
     }
     this.hints.push(hintset);
   }
   this.hintsLength = this.hints.length;
   this.requested = this.configuration.typespecifics.requested;
   this.notesEnd = this.configuration.typespecifics.notesEnd;
   this.notesStart = this.configuration.typespecifics.notesStart;
   this.onChangeRepr();
  }

  reset(){
    super.reset();
    this.title = this.get("discoveryExercise");
   this.hints = [[{value:undefined, representation:undefined}]];
   this.hintsLength = 1;
   this.hintSetsLength=[1];
   this.requested = [undefined,undefined];
   this.given = [undefined,undefined];
  }

   generateDefinition(): any{
    let definition = super.generateDefinition();
    definition.key = "dataRepresentation%discover%";
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.key = definition.key.concat(this.representation, "%", this.representationSpec.toString().replace(new RegExp(" ", 'g'), ""), "%", this.requested.toString())
    
    definition.typespecifics.hints = [];
    for(let set of this.hints){
      let array = [];
      for(let elem of set){
        array.push(elem.value);
      }
      definition.typespecifics.hints.push(array);
    }
    definition.typespecifics.requested = this.requested;
    definition.typespecifics.notesStart = this.notesStart;
    definition.typespecifics.notesEnd = this.notesEnd;
    definition.image = "./assets/images/discover.png";
    definition.level = 3;
    return definition;
   }

   /** adds a new hint */
   addHint(){
     this.hintsLength++;
     this.hints.push([{value:undefined, representation:undefined}]);
     this.hintSetsLength.push(1);
   }

   /**
    * deletes the given hint
    * @param i - hint to delete
    */
   deleteHint(i:number){
    this.hints.splice(i,1);
    this.hintSetsLength.splice[i];
    this.hintsLength--;
   }

   /**
    * adds a new row to given hint
    * @param i - hint to add row
    */
   addRow(i: number){
    this.hints[i].push({value:undefined, representation:undefined});
    this.hintSetsLength[i]++;
   }

   /**
    * deletes given row
    * @param i - index of hint
    * @param j - index of row
    */
   deleteRow(i,j:number){
    this.hints[i].splice(j,1);
    this.hintSetsLength[i]--;
   }

   /**
    * adjusts given row
    * @param i - index of hint
    * @param j - index of row
    */
   onChangeValue(i, j:number){
     if(this.representationDefined()){
     let value = this.hints[i][j].value;
     let representation = this.numberCardsService.getRepresentation(value, this.representation, this.representationSpec);
     this.hints[i][j].representation = representation;
     }
   }

   /**
    * change represntation of given row and compute corresponding value
    * @param i - index of hint
    * @param j - index of changed row
    */
   onChangeRepresentation(i, j: number){
    if(this.representationDefined()){
      let representation:number = this.hints[i][j].representation;
      let count:number[] = [];
      let index = this.cards.length - representation.toString().length;
      for(let digit of representation.toString()){
        if('0123456789'.indexOf(digit) == -1){
          switch(digit){
            case "a": digit = "10"; break;
            case "b": digit = "11"; break;
            case "c": digit = "12"; break;
            case "d": digit = "13"; break;
            case "e": digit = "14"; break;
            case "f": digit = "15"; break;
          }
        }
        count[this.cards[index]] = +digit;
        index++;
      }
      let value = this.numberCardsService.getValue(count);
      this.hints[i][j].value = value;
      }
      this.onChangeValue(i,j);
   }

   /** computes representation and value of requested
    * @param i - index of row
    */
   onChangeRequested(i:number){
    if(this.representationDefined()){
      let value = this.requested[i];
      let representation = this.numberCardsService.getRepresentation(value, this.representation, this.representationSpec);

      this.given[i] = representation;
      }
   }

   /**
    * computes representation and value of requested
    * @param i -index of changed row
    */
   onChangeGiven(i: number){
    if(this.representationDefined()){
      let representation:string = this.given[i];
      let count:number[] = [];
      let index = this.cards.length - representation.length;
      for(let digit of representation){
        if('0123456789'.indexOf(digit) == -1){
          switch(digit){
            case "a": digit = "10"; break;
            case "b": digit = "11"; break;
            case "c": digit = "12"; break;
            case "d": digit = "13"; break;
            case "e": digit = "14"; break;
            case "f": digit = "15"; break;
          }
        }
        count[this.cards[index]] = +digit;
        index++;
      }
      let value = this.numberCardsService.getValue(count);
      this.requested[i] = value;
      }
      this.onChangeRequested(i);
   }

   /**
    * when recomputes representation of all hints and requested
    */
   onChangeRepr(){
     super.onChangeRepr();
     for(let i in this.hints){
      for(let j of this.createArray(this.hints[i].length)){
        if(this.hints[i][j].value != undefined){
          this.onChangeValue(i,j);
        }
        if(this.hints[i][j].representation != undefined){
          this.onChangeRepresentation(i,j);
        }
      }
     }
     for(let i in this.requested){
       if(this.requested[i] != undefined){
         this.onChangeRequested(+i);
       }
       if(this.given[i] != undefined){
        this.onChangeGiven(+i);
       }
     }
   }

}
